import React, { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import "../../styles/global.css";
import { useAddWatsonAssistantScript } from "../../hooks/useWatsonAssistantScript";

export const Layout = ({ children }: { children: ReactNode }) => {
  if(process.env.GATSBY_CHATBOT_ENABLED === "true"){
    useAddWatsonAssistantScript();
  }
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};
